






































import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import { NotificationService } from '@/modules/notification/services/notification.service'
import { Prop } from 'vue-property-decorator'

@Component({
  inheritAttrs: false,
  components: {}
})
export default class MarkAllAsReadButton extends Vue {
  constructor(
    private readonly notificationService: NotificationService
  ) {
    super()
  }

  @Prop({ default: false }) asText!: boolean
  @Prop({ default: 'خواندن همه' }) label!: string
  clicked: boolean = false
  loading: boolean = false

  onClick() {
    this.loading = true
    this.notificationService.markAllAsRead().then(() => {
      this.clicked = true
      this.loading = false
      this.$emit('click')
    })
  }
}

